import React from 'react';
import Navbar from '../global/Navbar';
import Footer from '../global/Footer';
import ContactForm from './ContactForm';
import Newsletter from '../global/Newsletter';
import { PageFlow } from '../shared/SectionSurface';
import PageMeta from '../shared/PageMeta';


function Contact() {
  return (
    <div>
      <PageMeta path="/contact" />
      <Navbar />
      <PageFlow>
        <ContactForm />
      </PageFlow>
      <Newsletter />
      <Footer />
    </div>
  );
}

export default Contact;
